import { Box } from '@mui/material'

import { FourCardsGroup, OneCardGroup, ThreeCardsGroup, TwoCardsGroup } from '~entities/index'
import { getGridSchema } from '~features/grid'
import { EmptyPageContent } from '~sharedUI'

export const MonthEventsDisplayer = ({ events }: { events: any[] }) => {
	if (events.length === 0)
		return <EmptyPageContent />

	const eventsArray = [...events]
	const gridSchema = getGridSchema(events.length)

	const eventsComponentsArray = gridSchema.map((item, index) => {
		switch (item.count) {
			case 1:
				return (
					<OneCardGroup
						key={index}
						type={item.type as 1 | 2}
						events={eventsArray.splice(0, 1)}
					/>
				)
			case 2:
				return <TwoCardsGroup key={index} events={eventsArray.splice(0, 2)} />
			case 3:
				return (
					<ThreeCardsGroup
						key={index}
						type={item.type as 1 | 2 | 3 | 4}
						events={eventsArray.splice(0, 3)}
					/>
				)
			case 4:
				return (
					<FourCardsGroup
						key={index}
						type={item.type as 1 | 2}
						events={eventsArray.splice(0, 4)}
					/>
				)
			default:
				return null
		}
	})

	return (
		<Box
			display={'flex'}
			gap={'32px'}
			maxHeight={'800px'}
		>
			{eventsComponentsArray}
		</Box>
	)
}
